import {ChangeDetectorRef, Component, NgModule, OnInit} from '@angular/core';
import {ApiCapaService} from '../../../_services/apiCapa.service';
import {OAuthService} from 'angular-oauth2-oidc-codeflow';
import {AuthenticationService} from '../../../_services/authentication.service';
import {Router} from '@angular/router';
import {InstallModel} from '../../../_models/CapaModels/install.model';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {ExtendedEvaluationModel} from '../../../_models/CapaModels/ExtendedEvaluation.model';
import {AccountModel} from '../../../_models/CapaModels/Account.model';
import {Observable} from 'rxjs';
import {of} from 'rxjs/internal/observable/of';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-result-list',
  templateUrl: './result-list.component.html',
  styleUrls: ['./result-list.component.css']
})

@NgModule({
    imports: [NgbPaginationModule]
})

export class ResultListComponent implements OnInit {

    account: AccountModel;

    activeSearchTab = 'date';
    inactiveSearchTab = 'keyword';

    // Recherche
    searchMode = 'default';
    searchKeyword;
    dateFormat = require('dateformat');
    selectedMoment: Date[] = [];

    // Affichage des evaluations
    Evaluations: ExtendedEvaluationModel[] = [];
    page: number = 1;
    nbElementsPerPage: number = 10;
    nbTotalElements: number;
    orderBy = 'sujet';

    // Gestion des mode client/admin
    isAdmin: boolean;

    licenseList$: Observable<InstallModel[]>;
    license: InstallModel;

    constructor(private oauthService: OAuthService,
                private cdRef: ChangeDetectorRef,
                private authenticationService: AuthenticationService,
                private router: Router,
                private ApiClient: ApiCapaService) {
    }

    ngOnInit() {
        if (localStorage.getItem('isCapaAdmin') === 'true') {
            this.isAdmin = true;
        } else {
            this.isAdmin = false;
            this.account = JSON.parse(localStorage.getItem('capaAccount'));
        }

        if (this.isAdmin) {
            this.getLicense();
        } else {
            this.getLicenseList();
        }
    }

    onLicensePush($event) {
        this.getLicenseList();
    }

    // Change de tab dans la box 'Recherche'
    switchTab() {
        const temp = this.activeSearchTab;
        this.activeSearchTab = this.inactiveSearchTab;
        this.inactiveSearchTab = temp;
    }

    switchLicense(license) {
        this.license = license;
        this.page = 1;
        this.Request();
    }

    getLicense() {
        const IDInstall = this.router.url.split('/')[4];
        this.ApiClient.get ('Installs/' + IDInstall).subscribe(license => {
            this.license = license;
            this.Request();
        });
    }

    getLicenseList() {
        let Licenses: InstallModel[] = [];
        this.licenseList$ = of(Licenses);

        this.ApiClient.post('Installs/filtered-list', {'IDAccount' : this.account.idAccount}).subscribe(result => {
            Licenses = result.entities;
            this.Request();
            this.licenseList$ = of(Licenses);
        });
    }

    ResetSearch() {
        this.searchMode = 'default';
        this.searchKeyword = '';
        this.orderBy = 'sujet';
    }

    // Récupère les dernière évaluations connues pour cette license
    Request(pageNumber: number = 1) {
        const capaQuery = {
            Offset: (pageNumber - 1) * this.nbElementsPerPage,
            OrderBy: this.orderBy,
            Keyword: this.searchMode === 'default' ? null : (this.searchMode === 'date' ? null : this.searchKeyword),
            Dates: this.searchMode === 'default'
                ? null
                : (this.searchMode === 'keyword'
                    ? null
                    : [this.dateFormat(
                        this.selectedMoment[0], 'yyyy-mm-dd').toString(),
                        this.dateFormat(this.selectedMoment[1], 'yyyy-mm-dd').toString()
                        ]
                ),
            IDAccount: this.license == null ? this.account.idAccount : null,
            IDInstall: this.license != null ? this.license.idInstall : null
        };

        this.ApiClient.post('Evaluations/query', capaQuery).subscribe(response => {
            this.Evaluations = response['entities'];
            this.nbTotalElements = response['infos']['count'];
        });
    }

    // Construit un dictionnaire de données puis convertit la réponse de Capa.API en pdf
    GetCertification(evaluation: ExtendedEvaluationModel) {
        if (!evaluation.Conforme_D || !evaluation.Conforme_G) { return; }

        const lang: string = window.location.pathname.split('/')[2];
        let conform: string;

        // Impossible de gérer ça avec i18n
        switch (lang) {
            case 'fr':
                conform = 'CONFORME';
                break;
            case 'de':
                conform = 'KONFORM';
                break;
            case 'en':
                conform = 'COMPLIANT';
                break;
        }

        // Objet contenant toutes les données nécessaire à la construction du pdf
        const certificationData = {
            '[NOM]': evaluation.Nom,
            '[PRENOM]': evaluation.Prenom,
            '[GROUPE]' : evaluation.NomGroupe,
            '[PROTECTEUR]' : evaluation.PICB_G,
            '[FABRICANT]' : evaluation.Fournisseur,
            '[DB_G]' : evaluation.PSNA_G,
            '[DB_D]' : evaluation.PSNA_D,
            '[DB_MAX]' : evaluation.PSNA_G < evaluation.PSNA_D ? evaluation.Lact + evaluation.PSNA_G : evaluation.Lact + evaluation.PSNA_D,
            '[CONFORME_G]': conform,
            '[CONFORME_D]': conform,
            '[DATE]': new Date(evaluation.DateDebut).toLocaleDateString(),
            '[HEURE]': evaluation.HeureDebut
        };

        const data = { data: certificationData, lang: lang, type: this.license.isFitcheck ? 'QEOS' : 'CAPA'};

        this.ApiClient.post('certification/capa-certif', JSON.stringify(data)).subscribe(response => {
            const binaryImg = atob(response);
            const length = binaryImg.length;
            const arrayBuffer = new ArrayBuffer(length);
            const uintArray = new Uint8Array(arrayBuffer);

            for (let i = 0; i < length; i++) {
                uintArray[i] = binaryImg.charCodeAt(i);
            }
            const currentBlob = new Blob([uintArray], {type: 'application/pdf'});
            const pdfUrl = URL.createObjectURL(currentBlob);
            window.open(pdfUrl, '_blank');
        });
    }
}
